
import React from "react"
import { connect } from "react-redux"
import { sortBy } from "lodash"
import PropTypes from "prop-types"

import { 
  Form, ListGroup, ListGroupItem, Glyphicon
} from "react-bootstrap"

import CitySelector from "../cities/CitySelector.jsx"
import Button from "../components/Button.jsx"
import { l } from "../../lib/Tools.js"
import { translateCity, getText } from "../lib/text.js"

const NextCitySelector = props => {
  const { Cities, addCity, selected } = props
  const city = Cities[props.filterCity || "madrid"]

  return (
    <div>
      <Form inline style={{maxWidth: 300}}>
        <CitySelector
          cityId={props.filterCity}
          labelWidth={50}
          onChange={city => props.changeFilterCity(city)}
        />
      </Form>

      <div style={{zIndex: 10, overflowY: props.selected ? "hidden" : "scroll", maxHeight: 470}}>
        <ListGroup style={{ border: "1px solid rgb(51, 122, 183)", marginTop: 8 }}>
          { 
            props.filterCity && (
              <ListGroupItem
                key={"trip666"}
                style={{ position: "relative"}}
                disabled={props.filterCity == selected}
              >
                <div style={{maxWidth: 350}}>
                  {getText("Viaje a")} {translateCity(city)}
                </div>

                <div style={{position: "absolute", right: 25, top: 12}}>
                  { 
                    !props.selected && (
                      <div>
                        <Button
                          bsSize="xsmall"
                          style={{marginRight:10}}                            
                          onClick={() => addCity(props.filterCity)}
                          glyph="plus"
                        />
                        <Button
                          bsSize="xsmall"
                          onClick={() => addCity(props.filterCity, "last")}
                          glyph="fast-forward"
                        />
                      </div>
                    )
                  }
                </div>
              </ListGroupItem>
            )
          }
        </ListGroup>
      </div>
    </div>
  )
}

NextCitySelector.props = {
  // inherited from daddy 
  addCity:          PropTypes.func.isRequired,
  changeFilterCity: PropTypes.func.isRequired, 
  filterCity:       PropTypes.string.isRequired,
  selected:         PropTypes.string,

  // straight from connect
  Cities:           PropTypes.object.isRequired // { [string]: Object },
}

NextCitySelector.defaultProps = {
  selected: null
}

const mapStateToProps = state => ({ Cities: state.cities })

export default connect(mapStateToProps)(NextCitySelector)
